"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkIdentifierToJSON = exports.NetworkIdentifierFromJSONTyped = exports.NetworkIdentifierFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function NetworkIdentifierFromJSON(json) {
    return NetworkIdentifierFromJSONTyped(json, false);
}
exports.NetworkIdentifierFromJSON = NetworkIdentifierFromJSON;
function NetworkIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'blockchain': json['blockchain'],
        'network': json['network'],
        'sub_network_identifier': !runtime_1.exists(json, 'sub_network_identifier') ? undefined : _1.RosettaNetworkListResponseSubNetworkIdentifierFromJSON(json['sub_network_identifier']),
    };
}
exports.NetworkIdentifierFromJSONTyped = NetworkIdentifierFromJSONTyped;
function NetworkIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'blockchain': value.blockchain,
        'network': value.network,
        'sub_network_identifier': _1.RosettaNetworkListResponseSubNetworkIdentifierToJSON(value.sub_network_identifier),
    };
}
exports.NetworkIdentifierToJSON = NetworkIdentifierToJSON;
//# sourceMappingURL=NetworkIdentifier.js.map